<div class="release-page-layout flex-row flex-fill" *cbWaitFor="mappedItem">
    <mat-tab-group
        class="release-main-tabs flex"
        mat-stretch-tabs="false"
        [(selectedIndex)]="selectedTabIndex"
        [cbTabRoute]="RELEASE_ROUTE"
    >
        <mat-tab label="Details" cbTabRouteId="details">
            <form #releaseEditForm="ngForm">
                <cb-manage-project-release-stage-details
                    *cbWaitFor="mappedItem"
                    [mappedItem]="mappedItem"
                >
                </cb-manage-project-release-stage-details>
            </form>
        </mat-tab>
        <mat-tab label="Lots" cbTabRouteId="lots">
            <ng-template matTabContent>
                <cb-manage-project-release-stage-lots
                    *cbWaitFor="mappedItem"
                    [mappedItem]="mappedItem"
                    [selectedTabIndex]="lotsSelectedTabIndex"
                >
                </cb-manage-project-release-stage-lots>
            </ng-template>
        </mat-tab>
        @if (canViewReleaseDefaultInstallers) {
            <mat-tab label="Default Installers" cbTabRouteId="default-installers">
                <ng-template matTabContent>
                    <cb-release-default-installer *cbWaitFor="mappedItem" [mappedItem]="mappedItem">
                    </cb-release-default-installer>
                </ng-template>
            </mat-tab>
        }
        @if (isSupplierTypesEnabled && canViewReleaseDefaultSuppliers) {
            <mat-tab label="Default Suppliers" cbTabRouteId="default-suppliers">
                <ng-template matTabContent>
                    <cb-release-default-supplier *cbWaitFor="mappedItem" [mappedItem]="mappedItem">
                    </cb-release-default-supplier>
                </ng-template>
            </mat-tab>
        }
        @if (canViewReleaseTasks) {
            <mat-tab label="Tasks" cbTabRouteId="tasks">
                <ng-template matTabContent>
                    <cb-tasks
                        class="flex-col"
                        *cbWaitFor="mappedItem"
                        [entity]="mappedItem"
                        [edit]="true"
                        [permissions]="taskPermissions"
                    >
                    </cb-tasks>
                </ng-template>
            </mat-tab>
        }
        @if (canViewReleaseNotes) {
            <mat-tab label="Notes" cbTabRouteId="notes">
                <ng-template matTabContent>
                    <cb-notes
                        *cbWaitFor="mappedItem"
                        [entity]="mappedItem"
                        [edit]="true"
                        [permissions]="notePermissions"
                    >
                    </cb-notes>
                </ng-template>
            </mat-tab>
        }
        @if (canViewReleaseDocuments) {
            <mat-tab label="Documents" cbTabRouteId="documents">
                <ng-template matTabContent>
                    <cb-document
                        *cbWaitFor="mappedItem"
                        [entity]="mappedItem"
                        [permissions]="documentPermissions"
                        [includeLinked]="true"
                        [systemArea]="systemArea"
                        [showPdfButton]="true"
                    >
                    </cb-document>
                </ng-template>
            </mat-tab>
        }
        @if (canViewReleaseHistory) {
            <mat-tab label="History" cbTabRouteId="history">
                <ng-template matTabContent>
                    <cb-history-list
                        *cbWaitFor="mappedItem"
                        [entityId]="mappedItem?.id"
                        [entity]="HISTORY_SEARCH_ENTITY.ProjectReleaseStage"
                    >
                    </cb-history-list>
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
    @if (mappedItem) {
        <cb-manage-project-release-stage-side-bar-card
            class="release-sidebar cb-margin"
            [mappedItem]="mappedItem"
        >
        </cb-manage-project-release-stage-side-bar-card>
    }
</div>
